export const iconFontAwesomeTransportationSailboat = (
	<i className="fa-solid fa-sailboat"></i>
);
